import React, { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../../config/axiosApi/axiosApi";
import APIs from "../../../Constants/apis";
import Select from "react-select";
import DropDownStyles, { DropDownStylesDark } from "../../../pages/staff/dropdownStyles";
import { useSelector } from "react-redux";

const CountrySelector = ({
  value,
  onChange,
  placeholder = "Select Country",
  isDisabled = false,
  isClearable = true,
  className = "",
  styles = null
}) => {
  const isDarkMode = useSelector((state) => state.appSettings?.appDarkMode);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCountries = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(APIs.GET_COUNTRIES);
      const countryData = response.data.data || response.data;

      const mappedCountries = countryData.map((country) => ({
        value: country.code,
        label: country.name,
      }));
      
      setCountries(mappedCountries);
    } catch (err) {
      console.error("Error fetching countries:", err);
      setCountries([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCountries();
  }, [fetchCountries]);

  const handleChange = (selectedOption) => {
    if (onChange) {
      onChange(selectedOption ? selectedOption.value : "");
    }
  };

  const selectedCountry = countries.find(country => country.value === value) || null;

  return (
    <Select
      value={selectedCountry}
      onChange={handleChange}
      options={countries}
      styles={styles || (isDarkMode ? DropDownStylesDark : DropDownStyles)}
      placeholder={loading ? "Loading countries..." : placeholder}
      isDisabled={isDisabled || loading}
      isClearable={isClearable}
      isLoading={loading}
      className={className}
      noOptionsMessage={() => "No countries found"}
      loadingMessage={() => "Loading countries..."}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      menuShouldBlockScroll={false}
      menuShouldScrollIntoView={false}
      closeMenuOnScroll={false}
    />
  );
};

export default CountrySelector;
